import React, { useMemo } from 'react';
import {
  Button,
  Card,
  CardContent,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';
import {
  MenuBook as RelatedCatalogIcon,
} from '@mui/icons-material';
import { IEducationalVideoItem } from '../../../dataObjects/models/educationalVideos';
import { cardGridViewItemStyles } from '../../styles';
import { styled } from '@mui/styles';
import { useNavigate } from 'react-router-dom';


// a styled Typography for a Section Header
const StyledTypographyForTitle = styled((props: TypographyProps) => (
  <Typography
    variant='h6'
    {...props}
  />
))(({ theme }) => ({
  fontWeight: 'bolder',
  marginLeft: theme.spacing(2),
  marginBottom: theme.spacing(-1),
  color: theme.cardViewCard.titleColor,

  [theme.breakpoints.up('xs')]: {
    fontSize: '1.0rem',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.05rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.1rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.15rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.2rem',
  },

}));


export interface IEducationalVideosRelatedCatalogGridViewItemProps {
  relatedCatalog: IEducationalVideoItem;
}


export const EducationalVideosRelatedCatalogGridViewItem: React.FC<IEducationalVideosRelatedCatalogGridViewItemProps> = (props: IEducationalVideosRelatedCatalogGridViewItemProps) => {

  const { relatedCatalog } = props;

  const classes = cardGridViewItemStyles();

  // the 'useNavigate' hook will be used to navigate the browser
  const navigate = useNavigate();

  return (
    <>
      {/* <Card classes={{ root: classes.card }} elevation={6}> */}
      <Card elevation={6} className={classes.card}>

        {/* Note: Couldn't get proper behavior from <CardHeader>, so will just display a title via <Typography> */}
        <StyledTypographyForTitle>
          {relatedCatalog.title}
        </StyledTypographyForTitle>

        <CardContent>

          {/* {videoObjectForDisplay} */}

          <Typography className={classes.cardDescription} variant="body1">
            {relatedCatalog.description}
          </Typography>

          <div className={classes.drillDownButtonContainer}>
            <Tooltip
              // the tooltip for the drilldown button will either be "Drill down" (if user has sufficient permission) or "Drill down disallowed" (insufficient permission)
              title={'Click to view the related catalog details'}
              arrow
            >
              <span>
                <Button
                  className={classes.drillDownButton}
                  aria-label="related catalogs"
                  variant='contained'
                  size='medium'
                  startIcon={<RelatedCatalogIcon />}
                  onClick={() => {navigate(`/EducationalVideos/${relatedCatalog.id}`)}}
                >
                  {`View Catalog`}
                </Button>
              </span>
            </Tooltip>
          </div>

        </CardContent>
        {/* </CardActionArea> */}

      </Card>
    </>
  );

}